export default "__VITE_ASSET__f4631afc__"